import { useContext } from "react";
import TourContext from "../components/TourContext";
import type { TourContextValue } from "../types/tour.types";

export const useTour = (): TourContextValue | null => useContext(TourContext);

export default useTour;
